import React, { useState, useEffect } from "react";
import { Star } from "lucide-react";

const ClientReviews = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const reviews = [
    {
      id: 1,
      name: "Krida Bharti",
      comment:
        "Actively promote sports and fitness culture, ensuring young athletes get the best opportunities to grow and compete at every level.",
      avatar: "./assets/images/reviews/logo333.png",
    },
    {
      id: 2,
      name: "Fit India",
      comment:
        "Encouraging a healthy and active lifestyle, we strive to create an environment where fitness and sports go hand in hand. ",
      avatar: "./assets/images/reviews/fit-india_logo.png",
    },
    {
      id: 3,
      name: "Khelo India Program",
      comment:
        "A platform dedicated to nurturing sports talent, providing world-class facilities, and helping young athletes achieve their dreams.",
      avatar: "./assets/images/reviews/kheloindia.svg",
    },
    {
      id: 4,
      name: "Ministry of Youth Affairs and Sports",
      comment:
        "Committed to fostering sports excellence, providing top-notch infrastructure, and shaping the future of Indian sports.",
      avatar: "./assets/images/reviews/ministryyouth.png",
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % reviews.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="w-full py-12 md:py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 md:mb-16">
          We Work Under Supervision of
        </h2>

        <div className="relative h-[500px] md:h-[600px] overflow-hidden">
          {reviews.map((review, index) => (
            <div
              key={review.id}
              className={`absolute w-full transition-all duration-500 transform ${
                index === currentSlide
                  ? "opacity-100 translate-x-0"
                  : index < currentSlide
                  ? "opacity-0 -translate-x-full"
                  : "opacity-0 translate-x-full"
              }`}
              style={{ left: 0, right: 0 }}
            >
              <div className="bg-white shadow-xl rounded-lg p-6 md:p-10 text-center mx-auto max-w-3xl">
                <div className="aspect-square w-48 md:w-64 mx-auto mb-8 relative">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-contain"
                  />
                </div>

                <p className="text-gray-600 text-lg md:text-xl mb-6 md:mb-8 italic">
                  "{review.comment}"
                </p>

                <p className="font-semibold text-gray-800 text-xl md:text-2xl">
                  {review.name}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-6 md:mt-8 gap-3">
          {reviews.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 md:w-4 md:h-4 rounded-full transition-all ${
                index === currentSlide ? "bg-blue-600" : "bg-gray-300"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientReviews;
